window.GastonQuantityStepper = {
  parseConfig(el) {
    let max = null;
    if (el.dataset.qtyMax != null && el.dataset.qtyMax !== '') {
      const parsedMax = parseInt(el.dataset.qtyMax, 10);
      if (!Number.isNaN(parsedMax) && parsedMax > 0) max = parsedMax;
    }

    const parsedMin = parseInt(el.dataset.qtyMin, 10);
    const min = Number.isNaN(parsedMin) ? 0 : parsedMin;

    return {
      mode: el.dataset.qtyMode || 'piece',
      min,
      max,
      step: parseInt(el.dataset.qtyStep, 10) || 1,
      measureValue: parseFloat(el.dataset.qtyMeasureValue) || 1,
      measureUnit: el.dataset.qtyMeasureUnit || 'g',
    };
  },

  formatDisplay(cartQty, config) {
    if (config.mode === 'weight') {
      const total = cartQty * config.measureValue;
      const rounded = Math.round(total * 1000) / 1000;
      const n = Number.isInteger(rounded) ? rounded : parseFloat(rounded.toFixed(2));
      return `${n}${config.measureUnit}`;
    }
    return String(cartQty);
  },

  apply(stepper, cartQty, config) {
    const input = stepper.querySelector('[data-product-table-quantity]');
    const display = stepper.querySelector('[data-qty-display]');
    const prevBtn = stepper.querySelector('.product-table__qty-step--prev');
    const nextBtn = stepper.querySelector('.product-table__qty-step--next');

    if (input) input.value = String(cartQty);
    if (display) display.textContent = this.formatDisplay(cartQty, config);

    if (prevBtn) {
      prevBtn.disabled = cartQty <= config.min;
    }
    if (nextBtn) {
      nextBtn.disabled = config.max != null && cartQty >= config.max;
    }
  },

  walk(stepper, direction) {
    const config = this.parseConfig(stepper);
    const input = stepper.querySelector('[data-product-table-quantity]');
    let v = parseInt(input?.value, 10);
    if (Number.isNaN(v)) v = config.min;

    if (direction === 'prev') {
      v = Math.max(config.min, v - config.step);
    } else if (config.max != null) {
      v = Math.min(config.max, v + config.step);
    } else {
      v += config.step;
    }

    this.apply(stepper, v, config);
    return v;
  },

  reset(stepper) {
    const config = this.parseConfig(stepper);
    this.apply(stepper, config.min, config);
    return config.min;
  },

  init(root = document) {
    root.querySelectorAll('[data-product-table-qty-stepper]').forEach((stepper) => {
      const config = this.parseConfig(stepper);
      const input = stepper.querySelector('[data-product-table-quantity]');
      let v = parseInt(input?.value, 10);
      if (Number.isNaN(v)) v = config.min;
      v = Math.max(config.min, config.max != null ? Math.min(config.max, v) : v);
      this.apply(stepper, v, config);
    });

    root.querySelectorAll('quantity-input').forEach((el) => {
      if (typeof el.validateQtyRules === 'function') el.validateQtyRules();
    });
  },
};

function gastonQuantityStepperInit() {
  window.GastonQuantityStepper.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', gastonQuantityStepperInit);
} else {
  gastonQuantityStepperInit();
}

document.addEventListener('shopify:section:load', (event) => {
  window.GastonQuantityStepper?.init(event.target);
});
